import { type TableColumn, type TableWithGroupsColumn, TableDataCell, TableHeadCell } from "@mdotm/shadcn/legacy/components";
import { type DataAttributesProps, type DropdownDropdownItem, DropdownMenu } from "@mdotm/shadcn/mdotm/components";
import { CommonItemActions } from "./common-item-actions";
import { type MaybeFn, maybeCall, nullary } from "@mdotm/shadcn/legacy/utils";
import { TinyDropdownMenuTrigger } from "$root/components/DropdownMenuTrigger";

export function actionsColumn<TRow>(params: {
	onSettingsClick(): void;
	dropdownActions: MaybeFn<Array<DropdownDropdownItem>, [TRow]>;
	triggerProps?: DataAttributesProps;
	hideHeader?: boolean;
}): TableColumn<TRow> {
	return {
		name: settingsColumnName,
		header: (props) => (
			<TableHeadCell {...props} onClick={(e) => e.stopPropagation()}>
				{params.hideHeader ? <></> : <CommonItemActions.Settings onClick={nullary(params.onSettingsClick)} />}
			</TableHeadCell>
		),
		align: "middle",
		content: (row, props) => {
			const actions = maybeCall(params.dropdownActions, row);
			return (
				<TableDataCell {...props} onClick={(e) => e.stopPropagation()}>
					{actions.length ? (
						<DropdownMenu
							Trigger={TinyDropdownMenuTrigger}
							extraTriggerProps={params.triggerProps}
							actions={actions}
						/>
					) : (
						<></>
					)}
				</TableDataCell>
			);
		},
		minWidth: 40,
		maxWidth: 40,
	} satisfies TableColumn<TRow, string>;
}

export function groupActionsColumn<
	TGroup extends {
		rows: unknown[];
	},
>(params: {
	onSettingsClick(): void;
	dropdownActions: MaybeFn<Array<DropdownDropdownItem>, [TGroup]>;
	triggerProps?: DataAttributesProps;
	hideHeader?: boolean;
}): TableWithGroupsColumn<TGroup, string> {
	return {
		name: settingsColumnName,
		header: (props) => (
			<TableHeadCell {...props} onClick={(e) => e.stopPropagation()}>
				{params.hideHeader ? <></> : <CommonItemActions.Settings onClick={nullary(params.onSettingsClick)} />}
			</TableHeadCell>
		),
		align: "middle",
		groupContent: (row, props) => {
			const actions = maybeCall(params.dropdownActions, row);
			return (
				<TableDataCell {...props} onClick={(e) => e.stopPropagation()}>
					{actions.length ? (
						<DropdownMenu
							Trigger={TinyDropdownMenuTrigger}
							extraTriggerProps={params.triggerProps}
							actions={actions}
						/>
					) : (
						<></>
					)}
				</TableDataCell>
			);
		},
		content: () => null,
		minWidth: 40,
		maxWidth: 40,
	} satisfies TableWithGroupsColumn<TGroup, string>;
}

export const settingsColumnName = "settings-action";
